import { Title } from '@fnacdarty/back-office-ui';
import styled from 'styled-components';

export const StyledSortContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	position: relative;
`;

export const StyledIconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 5px;
	border: 1px solid transparent;
	border-radius: 5px;
	background-color: ${({ $isSorted, theme }) =>
		$isSorted ? theme.colors.primary : theme.colors.primaryLight};
	color: #ffffff;
	& > svg {
		cursor: pointer;
	}
	&:first-child {
		margin-right: 5px;
	}
`;

export const StyledSortListContainer = styled.div`
	position: absolute;
	top: 100%;
	right: 0;
	z-index: 1;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: center;
	width: 250px;
	height: 250px;
	overflow-y: auto;
	background-color: ${({ theme }) => theme.colors.background};
	border: 1px solid ${({ theme }) => theme.colors.separator};
	border-radius: 5px;
	box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
	visibility: ${({ $showList }) => ($showList ? 'visible' : 'hidden')};
	opacity: ${({ $showList }) => ($showList ? 1 : 0)};
	transition: visibility 0.3s, opacity 0.3s;
`;

export const StyledSortItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 50px;
	padding: 5px;
	border-radius: 5px;
	cursor: pointer;
	background-color: ${({ $isActive, theme }) =>
		$isActive ? theme.colors.primaryLight : '#ffffff'};
	color: ${({ $isActive, theme }) =>
		$isActive ? '#ffffff' : theme.colors.text};
	&:hover {
		background-color: ${({ theme }) => theme.colors.primaryLight};
		color: #ffffff;
	}
`;

export const StyledTitle = styled(Title)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	padding: 5px;
	margin-bottom: 5px;
	height: 50px;
`;
